var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepIco1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2217 26.6631V30.8877H31.7773V26.6631H32.333C33.253 26.6631 33.9998 27.3726 34 28.2471V31.416C33.9999 32.2905 33.2531 33 32.333 33H15.666C14.7462 32.9998 14.0001 32.2904 14 31.416V28.2471C14.0002 27.3728 14.7462 26.6633 15.666 26.6631H16.2217ZM29 15C29.92 15.0001 30.6659 15.7095 30.666 16.584V29.832H17.333V16.584C17.3331 15.7095 18.0799 15 19 15H29ZM28.1582 20.1406C27.8331 19.8202 27.307 19.8202 26.9854 20.1406L23.1465 23.9248L21.5215 22.3223C21.1964 22.0018 20.6703 22.0018 20.3486 22.3223C20.0273 22.6426 20.0239 23.1605 20.3486 23.4775L22.5625 25.6592C22.8876 25.9796 23.4127 25.9796 23.7344 25.6592L28.1582 21.2998C28.4833 20.9794 28.4833 20.4606 28.1582 20.1436V20.1406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIco1);
export default __webpack_public_path__ + "static/media/Step_ico_1.678fa6d8373dcfd0ee25d7dd031d019e.svg";
export { ForwardRef as ReactComponent };